import { withSvgIcon } from './withSvgIcon';

export const Link = withSvgIcon(
  <>
    <path
      d="M6 14V14C4.89543 14 4 13.1046 4 12V8C4 6.89543 4.89543 6 6 6H14C15.1046 6 16 6.89543 16 8V12C16 13.1046 15.1046 14 14 14H11"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M18 10V10C19.1046 10 20 10.8954 20 12V16C20 17.1046 19.1046 18 18 18H10C8.89543 18 8 17.1046 8 16V12C8 10.8954 8.89543 10 10 10H13"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
